// components/MUIDatatable/CustomMUIDataTablev2.js
import React, { useEffect } from "react";

import datatableTextLabels from "components/MUIDatatable/textLabels";

import { excelDownload } from "utils/excelDownload";

import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import GetAppIcon from "@material-ui/icons/GetApp";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import TablePagination from "@material-ui/core/TablePagination";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";

import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const {
    count,
    page,
    rowsPerPage,
    totalPages,
    changePage
  } = props;

  function handleFirstPageButtonClick() {
    changePage(0);
  }

  function handleBackButtonClick() {
    changePage(page - 1);
  }

  function handleNextButtonClick() {
    changePage(page + 1);
  }
  function handleBackFastButtonClick() {
    changePage(Math.max(page - 5, 0));
  }

  function handleNextFastButtonClick() {
    changePage(Math.min(page + 5, totalPages - 1));
  }

  function handleLastPageButtonClick() {
    changePage(totalPages - 1);
  }

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackFastButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardDoubleArrowRightIcon />
        ) : (
          <KeyboardDoubleArrowLeftIcon />
        )}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      {`${page + 1} de ${Math.ceil(totalPages)} páginas`}
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= totalPages - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextFastButtonClick}
        disabled={page >= totalPages - 1}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardDoubleArrowLeftIcon />
        ) : (
          <KeyboardDoubleArrowRightIcon />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= totalPages - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

function CustomFooter(props) {
  const {
    count,
    page,
    totalPages,
    rowsPerPage,

    changePage,
    changeRowsPerPage,

    textLabels,
    rowsPerPageOptions,
  } = props;

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={(event) => {
        changeRowsPerPage(parseInt(event.target.value, 10));
      }}
      labelRowsPerPage={textLabels.rowsPerPage}
      labelDisplayedRows={({ from, to, count }) =>
        `${from}-${to} ${textLabels.displayRows} ${count} registros`
      }
      rowsPerPageOptions={rowsPerPageOptions}
      ActionsComponent={(subprops) => (
        <TablePaginationActions
          {...subprops}
          count={count}
          page={page}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}

          changePage={changePage}
          changeRowsPerPage={changeRowsPerPage}
        />
      )}
    />
  );
}

export default function CustomMUIDataTable(props) {
  const MIN_TABLE_WIDTH = 200;
  const downloadEnabled = props.options?.download !== false;
  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MuiTableContainer: {
          root: { overflowX: "visible" },
        },
        MuiTable: {
          root: { minWidth: MIN_TABLE_WIDTH, tableLayout: "auto" },
        },

        MuiTableCell: {
          head: {
            backgroundColor: "#dadaf6 !important",
            position: "sticky",
            textAlign: "left",
            fontWeight: 400,
            zIndex: 2,
          },
          body: {
            display: "table-cell",
            verticalAlign: "middle",
            textAlign: "left",
            zIndex: 1,
          },
        },

        MUIDataTableHeadCell: {
          root: {
            textAlign: "left",
            fontWeight: 400,
            transition: "all 0.15s ease-in-out",
          },
          fixedHeader: { textAlign: "left" },
          contentWrapper: { justifyContent: "flex-start" },

          sortAction: {
            justifyContent: "flex-start",
            cursor: "pointer",
            backgroundColor: "rgba(255, 255, 255, 0.15)",
            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
            borderRadius: 4,
            transition: "all 0.15s ease-in-out",
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            },
          },

          sortActive: {
            color: "rgba(0,0,0,0.9)",
            backgroundColor: "rgba(255,255,255,0.25)",
            boxShadow: "0 2px 5px rgba(0,0,0,0.12)",
            fontWeight: 700,
          },

          toolButton: {
            justifyContent: "flex-start",
            textAlign: "left",
            "& svg": { opacity: 0.9 },
          },
        },

        MUIDataTableBodyCell: {
          root: {
            height: 15,
            whiteSpace: "nowrap",
            textAlign: "left",
          },
        },



        MUIDataTableToolbar: {
          root: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingRight: 8,
            width: "100%",            // ✅ agregar
          },
          filterPaper: {
            width: 480,
            maxWidth: "calc(100vw - 32px)",
          },
        },
        MUIDataTableToolbarTitle: {
          root: {
            flex: "1 1 auto",
            minWidth: 0,
            width: "100%",            // ✅ agregar
          },
        },
      },
    });

  const isLoading = !!props.options?.isLoading;
  const disableLoadingOverlay = props.options?.disableLoadingOverlay === true;

  return (
    <>
      <MuiThemeProvider theme={getMuiTheme}>
        <div
          style={{
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
            position: "relative",
            width: "100%",
          }}
        >
          <div style={{ minWidth: MIN_TABLE_WIDTH, position: "relative" }}>
            <MUIDataTable
              title={props.title}
              data={props.data}
              columns={props.columns}
              options={{
                responsive: "standard",
                filter: props.options?.filter !== false,
                filterList: props.filterList,
                onFilterChange: (column, filterList, type) => {
                  if (props.onFilterChange) props.onFilterChange(column, filterList, type);
                },
                onSearchChange: (searchText) => {
                  if (props.onSearchChange) props.onSearchChange(searchText);
                },
                search: props.options?.search !== false,
                serverSide: true,
                download: downloadEnabled,
                onDownload: downloadEnabled
                  ? () => {
                    if (props.onDownload) props.onDownload();
                    return false;
                  }
                  : undefined,
                filterType: props.filterType ? props.filterType : "checkbox",
                textLabels: {
                  ...datatableTextLabels(),
                  toolbar: {
                    ...datatableTextLabels().toolbar,
                    searchPlaceholder: props.options?.searchPlaceholder || "Buscar...",
                  },
                  // Si está cargando y no hay filas, mostramos "Cargando…" en el cuerpo
                  body: {
                    ...datatableTextLabels().body,
                    noMatch: isLoading ? "Cargando…" : datatableTextLabels().body.noMatch,
                  },
                },
                print: false,
                selectableRows: "none",
                viewColumns: false,
                tableBodyMaxHeight: "700px",
                fixedHeader: true,
                customFooter: (_count, _page, _rowsPerPage, _changeRowsPerPage, _changePage, _textLabels) =>
                  props.options?.pagination !== false && (
                    <CustomFooter
                      count={props.count}
                      page={props.page}
                      totalPages={props.totalPages}
                      rowsPerPage={props.rowsPerPage}
                      changePage={props.changePage}
                      changeRowsPerPage={props.changeRowsPerPage}
                      textLabels={_textLabels}
                      rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    />
                  ),
                ...props.options,
              }}
            />

            {/* Overlay de Carga */}
            {isLoading && !disableLoadingOverlay && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 12,
                  background: "rgba(255,255,255,0.6)",
                  backdropFilter: "blur(1px)",
                  zIndex: 5,
                }}
              >
                <CircularProgress size={28} />
                <Typography variant="body2">Cargando…</Typography>
              </div>
            )}

          </div>
        </div>
      </MuiThemeProvider>
    </>
  );
}
